import { useMemo } from "react";
import { useDispatch } from "react-redux";
import styled, { useTheme } from "styled-components";
import useChart from "../hooks/useChart";
import { toggleProduct, toggleProductKind } from "../store/chart";
import { Filters } from "./Filters";

type ProductFiltersProps = {
  className?: string;
};

export function ProductFilters({ className }: ProductFiltersProps) {
  const dispatch = useDispatch();
  const { isMobile } = useTheme();
  const {
    data: {
      styling,
      useCustomProductFilters,
      productFilters,
      showAdditionalFilterButton,
      additionalFilterButton,
      desktop,
      mobile,
    },
  } = useChart();
  const selectedProductKindIds = useMemo(
    () =>
      desktop.selectedProductKindFilters
        .filter(
          (selectedProductKindFilter) => selectedProductKindFilter.selected,
        )
        .map((selectedProductKindFilter) => selectedProductKindFilter.id),
    [desktop.selectedProductKindFilters],
  );
  const selectedProductIds = useMemo(
    () =>
      isMobile
        ? mobile.selectedProducts
            .filter((selectedProduct) => selectedProduct.selected)
            .map((product) => product.id)
        : desktop.selectedProducts
            .filter((selectedProduct) => selectedProduct.selected)
            .map((product) => product.id),
    [mobile.selectedProducts, desktop.selectedProducts, isMobile],
  );

  const shouldShowFiltersInDesktop =
    desktop.customProductFilters.length > 1 ||
    (desktop.customProductFilters.length === 1 &&
      showAdditionalFilterButton &&
      !!additionalFilterButton);

  function handleProductKindToggle(filterId: string) {
    dispatch(toggleProductKind(filterId));
  }

  function handleProductToggle(filterId: string) {
    dispatch(toggleProduct({ productId: filterId, isMobile }));
  }

  return (
    <Container className={className}>
      {!isMobile && useCustomProductFilters ? (
        shouldShowFiltersInDesktop && (
          <Filters
            styling={styling}
            filters={desktop.customProductFilters}
            showFilters
            additionalFilterButton={additionalFilterButton}
            showAdditionalFilterButton={showAdditionalFilterButton}
            selectedFilterIds={selectedProductKindIds}
            onFilterToggle={handleProductKindToggle}
          />
        )
      ) : (
        <Filters
          styling={styling}
          filters={productFilters}
          showFilters={(isMobile && productFilters.length <= 4) || !isMobile}
          showAdditionalFilterButton={false}
          selectedFilterIds={selectedProductIds}
          onFilterToggle={handleProductToggle}
        />
      )}
    </Container>
  );
}

const Container = styled.div`
  margin-top: ${({ theme }) =>
    theme.isMobile ? theme.getValue(20) : theme.getValue(40)}px;
`;
